exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".faq .header[data-v-641d9d6c]{position:relative;cursor:pointer}.faq .header[data-v-641d9d6c]:after{content:\"\";background-image:url(/svg/chevron-down.svg);background-size:cover;background-position:50%;background-repeat:no-repeat;width:24px;height:24px;position:absolute;right:0;top:24px;transition:transform .2s}.faq .header.open[data-v-641d9d6c]:after{transform:rotate(-180deg)}.faq .content p[data-v-641d9d6c]{margin-top:4px;margin-bottom:24px;line-height:1.25rem}.faq[data-v-641d9d6c]  .v-collapse-group>div:last-child{border:0}", ""]);

// exports
